import { useState } from 'react'
import { apiCompartilhar } from '../lib/api'
import { openWhatsApp } from '../lib/openWhatsApp'
import { WhatsAppIcon } from './WhatsAppIcon'

type ShareTipo = 'noticia' | 'video' | 'moldura' | 'colinha'
type ShareCanal = 'whatsapp' | 'facebook' | 'x' | 'copiar'

type Props = {
  url: string
  title: string
  tipo?: ShareTipo
  id?: number
}

export function ShareButtons({ url, title, tipo, id }: Props) {
  const [copyOk, setCopyOk] = useState(false)
  if (!url) return null

  const wa = `https://wa.me/?text=${encodeURIComponent(`${title} ${url}`)}`
  const fb = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`
  const x = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`

  async function track(canal: ShareCanal) {
    if (tipo && id) {
      await apiCompartilhar(tipo, id, canal)
    }
  }

  async function openShare(canal: ShareCanal, href: string) {
    await track(canal)
    if (canal === 'whatsapp') {
      openWhatsApp(href)
      return
    }
    window.open(href, '_blank', 'noopener,noreferrer')
  }

  async function copy() {
    await track('copiar')
    try {
      await navigator.clipboard.writeText(url)
      setCopyOk(true)
      setTimeout(() => setCopyOk(false), 2000)
    } catch {
      window.prompt('Copie o link:', url)
    }
  }

  return (
    <div className="bp-share">
      <span className="bp-muted">Compartilhar:</span>
      <button type="button" className="bp-share__btn bp-share__btn--wa" onClick={() => void openShare('whatsapp', wa)}>
        <WhatsAppIcon />
        WhatsApp
      </button>
      <button type="button" className="bp-share__btn bp-share__btn--fb" onClick={() => void openShare('facebook', fb)}>
        Facebook
      </button>
      <button type="button" className="bp-share__btn bp-share__btn--x" onClick={() => void openShare('x', x)}>
        X
      </button>
      <button type="button" className="bp-share__btn" onClick={() => void copy()}>
        {copyOk ? 'Copiado!' : 'Copiar link'}
      </button>
    </div>
  )
}
